
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/a-public/[slug]",
      function () {
        return require("private-next-pages/a-public/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/a-public/[slug]"])
      });
    }
  